import React, {useEffect, useRef, useState} from 'react';
import platformContainer from '../../assets/images/about/section_01_platform_container.png';
import marketingContainer from '../../assets/images/about/section_01_marketing_container.png';
import tradeContainer from '../../assets/images/about/section_01_trade_container.png';

function AboutSection1() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="w-full bg-[#F7F7F7] text-black lg:mb-0 pt-[74px] md:pt-[144px] lg:pt-[100px]"
    >
      <div className={`container lg:pb-[100px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        {/* 섹션 제목 */}
        <div className="mb-[74px] md:mb-[112px] lg:mb-[74px]">
          <p className="text-26 md:text-xl font-semibold text-center">About</p>
        </div>

        {/* 메인 텍스트 - 노란색 강조 */}
        <div className={'mb-[34px] md:mb-[54px] lg:mb-[34px]'}>
          {/*<div className={`mb-[40px] lg:mb-[74px] transition-all duration-[2000ms] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>*/}
          <div className="text-32 md:text-5xl lg:text-44 font-medium text-center">
            글로벌 라이프스타일 트렌드 기업,  <span className="font-extrabold">'챙기고'</span>
          </div>
        </div>

        {/* 회사 소개 텍스트 */}
        <div
          className={`mb-[100px] md:mb-[172px] lg:mb-[140px]`}>
          {/* 모바일 버전 (md 미만에서만 표시) */}
          <p
            className="text-22 md:text-3xl lg:text-xl leading-[1.6] text-center font-normal max-w-[1200px] mx-auto lg:hidden">
            K-Beauty와 K-Pop을 기반으로<br/>
            한국의 라이프스타일을 콘텐츠와 플랫폼, 유통으로 연결하며<br/>
            글로벌 시장에 새로운 장르를 제안하고 트렌드를 이끄는 기업입니다.
          </p>

          {/* 데스크탑 버전 (md 이상에서만 표시) */}
          <p className="hidden lg:block text-2xl text-center leading-[1.6] font-normal">
            K-Beauty와 K-Pop을 기반으로 한국의 라이프스타일을 콘텐츠와 플랫폼, 유통으로 연결하며<br/>
            글로벌 시장에 새로운 장르를 제안하고 트렌드를 이끄는 기업입니다.
          </p>
        </div>


        <div className="lg:block pb-32 lg:pb-20">
          <div className={`grid grid-cols-1 lg:grid-cols-3 gap-2`}>

            {/* 플랫폼 */}
            <div className="text-center">
              <div className="flex flex-col items-center justify-center relative mb-12 lg:mb-20">
                <img src={platformContainer} alt="Platform" className="max-w-xs"/>
                <p
                  className="text-white text-26 md:text-34 lg:text-26 font-extrabold absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                  PLATFORM
                </p>
              </div>
              <p className="text-3xl md:text-42 lg:text-26 font-bold mb-4 md:mb-8 lg:mb-[26px]">AR, AI 기술을 적용한 글로벌 플랫폼</p>
              <p className="text-22 md:text-3xl lg:text-xl leading-[1.6] font-light mb-[100px] md:mb-36 lg:mb-0">
                뷰티와 기술이 결합된 스마트 커머스를 통해<br/>
                국내 고객과 전 세계에 K-Beauty 경험을 제공합니다.
              </p>
            </div>

            {/* 마케팅 */}
            <div className="text-center">
              <div className="flex items-center justify-center relative mb mb-12 lg:mb-20">
                <img src={marketingContainer} alt="Marketing" className="max-w-xs"/>
                <p
                  className="text-white text-26 md:text-34 lg:text-26 font-extrabold absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                  MARKETING
                </p>
              </div>

              <p className="text-3xl md:text-42 lg:text-26 font-bold mb-4 md:mb-8 lg:mb-[26px]">K-Content 기반 마케팅 전개</p>
              <p className="text-22 md:text-3xl lg:text-xl leading-[1.6] font-light mb-[100px] md:mb-36 lg:mb-0">
                K-Beauty, K-Pop 등 콘텐츠를 활용한<br/>
                브랜드 맞춤형 마케팅 전략을 기획하고 실행합니다.
              </p>
            </div>

            {/* 트레이드 */}
            <div className="text-center">
              <div className="flex items-center justify-center relative mb mb-12 lg:mb-20">
                <img src={tradeContainer} alt="Trade" className="max-w-xs"/>
                <p
                  className="text-white text-26 md:text-34 lg:text-26 font-extrabold absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                  TRADE
                </p>
              </div>
              <p className="text-3xl md:text-42 lg:text-26 font-bold mb-4 md:mb-8 lg:mb-[26px]">수입·수출 / 브랜드 총판 계약</p>
              <p className="text-22 md:text-3xl lg:text-xl leading-[1.6] font-light">
                글로벌 유통과 브랜드 총판 계약을 통해<br/>
                한국과 해외를 잇는 Lifestyle 확산에 앞장섭니다.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/*<div className="h-[140px] lg:h-[100px] bg-gradient-to-t from-[#1C1C1C] to-black"/>*/}
    </section>
  );
}

export default AboutSection1;